import * as React from 'react'
import { DIVERSITY_TABLE_COLUMN_WIDTHS } from '../extra/tableColumnWidths'
import TableColgroup from './TableColgroup'
import TableEmptyMessage from './TableEmptyMessage'

const DEFAULT_GENDER_LABELS = {
  all: '全労働者',
  regular: '正規雇用労働者',
  nonRegular: 'パート・有期労働者'
}

/**
 * @param {{
 *   rows: import('../extra/types').DiversityRow[]
 *   genderLabels?: import('../extra/types').GenderLabels
 * }} props
 */
const DiversityTable = ({ rows, genderLabels = DEFAULT_GENDER_LABELS }) => {
  const hasData = (rows ?? []).length > 0

  return (
    <div className="mb-8 px-12">
      <h3 className="text-base font-semibold mb-4 p-0">
        ④ 管理職に占める女性労働者の割合、男性労働者の育児休業取得率及び労働者の男女の賃金の差異
      </h3>
      {!hasData ? (
        <TableEmptyMessage />
      ) : (
        <table
          className="securities-report-indicators__table securities-report-indicators__table--diversity"
          id="diversity-table"
        >
          <TableColgroup widths={DIVERSITY_TABLE_COLUMN_WIDTHS} />
          <thead>
            <tr>
              <th rowSpan={2} className="company-name-col" align="center">
                会社名
              </th>
              <th rowSpan={2} align="center">
                管理職に占める女性労働者の割合(%)
              </th>
              <th colSpan={3} align="center">
                男性労働者の育児休業取得率(%)
              </th>
              <th colSpan={3} align="center">
                労働者の男女の賃金の差異(%)
              </th>
            </tr>
            <tr>
              <th align="center">{genderLabels.all}</th>
              <th align="center">{genderLabels.regular}</th>
              <th align="center">{genderLabels.nonRegular}</th>
              <th align="center">{genderLabels.all}</th>
              <th align="center">{genderLabels.regular}</th>
              <th align="center">{genderLabels.nonRegular}</th>
            </tr>
          </thead>
          <tbody>
            {rows.map((row) => (
              <tr key={row.name}>
                <td className="company-name-col" title={row.name}>
                  {row.name}
                </td>
                <td align="center">{row.mgmt}</td>
                <td align="center">{row.male[0]}</td>
                <td align="center">{row.male[1]}</td>
                <td align="center">{row.male[2]}</td>
                <td align="center">{row.wage[0]}</td>
                <td align="center">{row.wage[1]}</td>
                <td align="center">{row.wage[2]}</td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  )
}

export default DiversityTable
